import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.195 5.99h-1.25a6.453 6.453 0 1 1-1.398 4.012A.523.523 0 1 0 2.5 10a7.5 7.5 0 1 0 1.68-4.732V3.975a.523.523 0 0 0-1.046 0v2.537c0 .29.235.524.524.524h2.537a.523.523 0 0 0 0-1.047Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.525 5.815a.523.523 0 0 0-1.047 0v4.189c0 .139.055.272.153.37l2.958 2.958a.523.523 0 0 0 .74-.74l-2.804-2.805V5.815Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }